module.exports = __webpack_public_path__ + "static/mpost3.61ef061e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slideshow/mpost3.jpg
// module id = 997
// module chunks = 35783957827783